module.exports = __webpack_public_path__ + "media/src/images/user/group_of_users-a2c4a6e457cac01a63617b6b53dd94ee.png";